export enum FilterValues {
  'IsSample_true' = 'PRODUCT_LIST_PAGE_SAMPLES_ITEM',
  'IsSample_false' = 'PRODUCT_LIST_PAGE_NON_SAMPLES_ITEM',
}
